import { render, staticRenderFns } from "./ProductDropdowns.vue?vue&type=template&id=cd1cd47e&lang=pug&"
import script from "./ProductDropdowns.vue?vue&type=script&lang=js&"
export * from "./ProductDropdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports